// extracted by mini-css-extract-plugin
export default {"invoicePage":"PrintInvoice_invoicePage__NXGAn","titleGroup":"PrintInvoice_titleGroup__54t3I"};